import Vue from 'vue'
import HotelMap from './hotel-map.vue'
import CareerListing from './career-listing.vue'

if (jQuery('#hotel-map').length > 0) {
  new Vue({
    render: h => h(HotelMap)
  }).$mount('#hotel-map')
}

if (jQuery('#career-listing').length > 0) {
  new Vue({
    render: h => h(CareerListing)
  }).$mount('#career-listing')  
}


// WEBPACK FOOTER //
// ./src/main.js